module.exports = __webpack_public_path__ + "media/src/public/fonts/Intro-Regular-371659fef7de1c52a72f9036fed19c0a.woff2";